function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import dotProp from 'dot-prop-immutable';
import uuid from 'uuid/v4';
var defaultState = {
  // title: null,
  // documents: [],
  // attachments: [],
  // signers: [],
  isCreating: false,
  isLoading: false,
  isLoaded: false,
  data: null,
  error: null,
  fileUploadErrors: [],
  ui: {
    signMethods: null
  },
  features: {
    handwritten: {
      available: false,
      defaultValue: false
    },
    share: {
      available: false,
      defaultValue: false
    },
    forwarding: {
      available: false,
      defaultValue: false
    }
  }
};
var recipientIsEmpty = function recipientIsEmpty(recipient) {
  var _recipient$data, _recipient$data2, _recipient$data3, _recipient$data4, _recipient$data5, _recipient$data6;
  if (!recipient.isNew) return false;
  // This check can be improved, but it's a start
  // here
  return !((_recipient$data = recipient.data) !== null && _recipient$data !== void 0 && _recipient$data.firstName) && !((_recipient$data2 = recipient.data) !== null && _recipient$data2 !== void 0 && _recipient$data2.lastName) && !((_recipient$data3 = recipient.data) !== null && _recipient$data3 !== void 0 && _recipient$data3.companyName) && !((_recipient$data4 = recipient.data) !== null && _recipient$data4 !== void 0 && _recipient$data4.companyRole) && !((_recipient$data5 = recipient.data) !== null && _recipient$data5 !== void 0 && _recipient$data5.email) && !((_recipient$data6 = recipient.data) !== null && _recipient$data6 !== void 0 && _recipient$data6.mobileNumber);
};
var createRecipient = function createRecipient(recipient, isOrdered, recipients, features) {
  var _recipient$firstName, _recipient$lastName, _recipient$companyNam, _recipient$companyRol, _recipient$email, _recipient$mobileNumb;
  var data = {
    addHandwrittenSignature: false,
    firstName: (_recipient$firstName = recipient === null || recipient === void 0 ? void 0 : recipient.firstName) !== null && _recipient$firstName !== void 0 ? _recipient$firstName : '',
    lastName: (_recipient$lastName = recipient === null || recipient === void 0 ? void 0 : recipient.lastName) !== null && _recipient$lastName !== void 0 ? _recipient$lastName : '',
    companyName: (_recipient$companyNam = recipient === null || recipient === void 0 ? void 0 : recipient.companyName) !== null && _recipient$companyNam !== void 0 ? _recipient$companyNam : '',
    companyRole: (_recipient$companyRol = recipient === null || recipient === void 0 ? void 0 : recipient.companyRole) !== null && _recipient$companyRol !== void 0 ? _recipient$companyRol : '',
    email: (_recipient$email = recipient === null || recipient === void 0 ? void 0 : recipient.email) !== null && _recipient$email !== void 0 ? _recipient$email : '',
    language: '',
    required: !isOrdered,
    emailNotification: !!(recipient !== null && recipient !== void 0 && recipient.email),
    smsNotification: features ? !!(recipient !== null && recipient !== void 0 && recipient.mobileNumber) && ['disabled_true', 'default_true'].includes(features.smsNotification) : !!(recipient !== null && recipient !== void 0 && recipient.mobileNumber),
    signatureMethods: [],
    mobileNumber: (_recipient$mobileNumb = recipient === null || recipient === void 0 ? void 0 : recipient.mobileNumber) !== null && _recipient$mobileNumb !== void 0 ? _recipient$mobileNumb : '',
    addons: {
      shareDocumentAfterSigned: ['disabled_true', 'default_true'].includes(features === null || features === void 0 ? void 0 : features.secureShare) && !!recipient
    },
    order: isOrdered ? Math.max.apply(Math, _toConsumableArray(recipients.map(function (r) {
      return r.order;
    }))) + 1 : 0,
    signerRoles: {},
    authBeforeSign: features ? !!(recipient !== null && recipient !== void 0 && recipient.mobileNumber) && ['disabled_true', 'default_true'].includes(features.requireAuthentication) ? 'sms' : 'none' : !!(recipient !== null && recipient !== void 0 && recipient.mobileNumber) ? 'sms' : 'none'
  };
  var isClean = !recipient || Object.keys(recipient).length === 0;
  return {
    isContact: !!(recipient !== null && recipient !== void 0 && recipient.isContact),
    isNew: true,
    isDirty: !isClean,
    id: uuid(),
    data: data
  };
};
var applyOrderToFeatures = function applyOrderToFeatures(order) {
  var uiFeatures = order.uiFeatures;
  var handwritten = {
    available: uiFeatures.showAddHandwritten === true
  };
  var priv = {
    disabled: /disabled/.test(uiFeatures["private"])
  };
  var shareEnabled = function shareEnabled() {
    switch (uiFeatures.showShare) {
      case 'hidden':
        return false;
      case 'enabled_with_email_and_sms':
      case 'enabled_with_email_and_SMS':
        return false;
      default:
    }
  };
  var share = {
    disabled: shareEnabled === false
  };
  var forwarding = {
    available: /hidden/.test(uiFeatures.showForwarding) === false,
    disabled: /disabled/.test(uiFeatures.showForwarding)
  };
  var authBeforeSign = {
    available: /hidden/.test(uiFeatures.authBeforeSign) === false,
    disabled: /disabled/.test(uiFeatures.authBeforeSign)
  };
  return _objectSpread(_objectSpread({}, defaultState.features), {}, {
    handwritten: handwritten,
    "private": priv,
    share: share,
    forwarding: forwarding,
    authBeforeSign: authBeforeSign
  });
};
var getFile = function getFile(state, fileCategory, fileId) {
  return fileCategory === 'document' ? state.data.documents.filter(function (item) {
    return item.id === fileId;
  })[0] : state.data.attachments.filter(function (item) {
    return item.id === fileId;
  })[0];
};
export default (function () {
  var _action$order$signers;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'ORDER_INITIALIZE_REQUEST':
      return _objectSpread(_objectSpread({}, state), {}, {
        isCreating: true,
        isLoading: true
      });
    case 'ORDER_INITIALIZE_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        features: applyOrderToFeatures(action.order),
        data: _objectSpread(_objectSpread({
          metaData: {
            title: '',
            description: ''
          },
          documents: [],
          attachments: [],
          signers: [],
          contactDetails: {},
          permissions: {
            users: null,
            groups: null
          }
        }, action.order), {}, {
          signers: (_action$order$signers = action.order.signers) !== null && _action$order$signers !== void 0 && _action$order$signers.length ? action.order.signers.map(function (signer) {
            return {
              id: signer.id,
              isNew: false,
              data: _objectSpread({}, signer)
            };
          }) : [createRecipient(null)]
        }),
        isCreating: false,
        error: null,
        isLoading: false,
        isLoaded: true,
        uploads: []
      });
    case 'ORDER_SET_PERMISSIONS_USERS':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          permissions: _objectSpread(_objectSpread({}, state.data.permissions), {}, {
            users: action.users
          })
        })
      });
    case 'ORDER_SET_PERMISSIONS_GROUPS':
      return dotProp.set(state, 'data.permissions.groups', action.groups);
    case 'ORDER_INITIALIZE_FAILURE':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: {
          message: 'Could not create new sign order'
        },
        isLoading: false,
        isLoaded: true
      });
    case 'ORDER_PERMISSION_DENIED':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: {
          message: 'Access denied'
        },
        isLoading: false,
        isLoaded: true
      });
    case 'ORDER_SET_AVAILABLE_IDPS':
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          idps: action.idps ? _toConsumableArray(action.idps) : null
        })
      });
    case 'ORDER_SET_AVAILABLE_SIGN_METHODS':
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          signMethods: action.signMethods
        })
      });
    case 'ORDER_SET_SIGN_METHODS':
      return _objectSpread(_objectSpread({}, state), {}, {
        signMethods: _toConsumableArray(action.signMethods)
      });
    case 'ORDER_UPDATE_CONTACT':
      return _objectSpread(_objectSpread({}, state), {}, {
        contactDetails: _objectSpread(_objectSpread({}, state.contactDetails), {}, _defineProperty({}, action.field, action.value))
      });
    case 'ORDER_UPDATE_FIELD':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, _defineProperty({}, action.field, action.value))
      });
    case 'ORDER_UPDATE_NUMBER_OF_SIGNERS':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          advanced: _objectSpread(_objectSpread({}, state.data.advanced || {}), {}, {
            numberOfSigners: action.value
          })
        })
      });
    case 'ORDER_SET_USE_FORWARDING':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          advanced: _objectSpread(_objectSpread({}, state.data.advanced || {}), {}, {
            useForwarding: action.value
          })
        })
      });
    case 'ORDER_SET_AUTH_BEFORE_SIGN':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: state.data.signers.map(function (item) {
            // If signerId is provided, only update the signer with matching id
            if (action.signerId && action.signerId !== item.id) {
              return item;
            }
            return _objectSpread(_objectSpread({}, item), {}, {
              isDirty: true,
              data: _objectSpread(_objectSpread({}, item.data), {}, {
                // If mobile is not set, then no authBeforeSign
                authBeforeSign: item.mobile ? action.value : 'none'
              })
            });
          })
        })
      });
    case 'ORDER_UPDATE_REMINDERS':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          notificationSettings: _objectSpread(_objectSpread({}, state.data.notificationSettings || {}), {}, {
            reminder: action.value
          })
        })
      });
    case 'ORDER_UPDATE_AUTHOR_NOTIFICATIONS':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          notificationSettings: _objectSpread(_objectSpread({}, state.data.notificationSettings || {}), {}, {
            sendReceiptsToAuthor: action.value
          })
        })
      });
    case 'ORDER_UPDATE_TITLE':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          metaData: _objectSpread(_objectSpread({}, state.data.metaData), {}, {
            title: action.value
          })
        })
      });
    case 'ORDER_UPDATE_DESCRIPTION':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          metaData: _objectSpread(_objectSpread({}, state.data.metaData), {}, {
            description: action.value
          })
        })
      });
    case 'ORDER_SAVE_SUCCESS':
      // TODO: Miiight want to replace the whole object, must try
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          notificationSettings: _objectSpread(_objectSpread({}, action.order.notificationSettings), state.data.notificationSettings),
          metaData: _objectSpread(_objectSpread({}, state.data.metaData), {}, {
            lastUpdated: action.order.metaData.lastUpdated,
            etag: action.order.metaData.etag
          }),
          documents: _toConsumableArray(action.order.documents),
          attachments: _toConsumableArray(action.order.attachments)
        })
      });
    case 'ADD_UPLOAD':
      return _objectSpread(_objectSpread({}, state), {}, {
        uploads: [].concat(_toConsumableArray(state.uploads), [action.file])
      });
    case 'REMOVE_UPLOAD':
      return _objectSpread(_objectSpread({}, state), {}, {
        uploads: _toConsumableArray(state.uploads).filter(function (upload) {
          return upload.id !== action.file.id;
        })
      });
    case 'ADD_DOCUMENT':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          documents: [].concat(_toConsumableArray(state.data.documents), [action.file])
        }),
        uploads: _toConsumableArray(state.uploads).filter(function (file) {
          return file.id !== action.file.id;
        })
      });
    case 'SET_ETAG':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          metaData: _objectSpread(_objectSpread({}, state.data.metaData), {}, {
            etag: action.etag
          })
        })
      });
    case 'ADD_ATTACHMENT':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          attachments: [].concat(_toConsumableArray(state.data.attachments), [action.file])
        }),
        // foreach recipient add signerRoles
        uploads: _toConsumableArray(state.uploads).filter(function (file) {
          return file.id !== action.file.id;
        })
      });
    case 'REMOVE_DOCUMENT':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          documents: _toConsumableArray(state.data.documents.filter(function (item) {
            return item.id !== action.id;
          }))
        })
      });
    case 'REMOVE_ATTACHMENT':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          attachments: _toConsumableArray(state.data.attachments.filter(function (item) {
            return item.id !== action.id;
          }))
        })
      });
    case 'REPAIR_FILE_INIT':
      var initRepairFile = getFile(state, action.category, action.id);
      initRepairFile.validationResult.isRepairing = true;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread({}, state.data)
      });
    case 'REPAIR_FILE_COMPLETED':
      var document = getFile(state, action.category, action.id);
      document.validationResult.fileIsValid = action.fileIsValid;
      document.validationResult.wasRepairedBySigniapp = true;
      document.validationResult.isRepairing = false;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread({}, state.data)
      });
    case 'REPAIR_FILE_ERROR':
      var fileWithError = getFile(state, action.category, action.id);
      fileWithError.validationResult.wasRepairedBySigniapp = true;
      fileWithError.validationResult.isRepairing = false;
      fileWithError.validationResult.fileIsValid = false;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread({}, state.data)
      });
    case 'ADD_RECIPIENT':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: [].concat(_toConsumableArray(state.data.signers.filter(function (signer) {
            return !recipientIsEmpty(signer);
          })), [createRecipient(action.recipient, action.isOrdered, state.data.signers.map(function (s) {
            return s.data;
          }), state.data.uiFeatures)])
        })
      });
    case 'SET_RECIPIENT_EMAIL':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: state.data.signers.map(function (signer) {
            return signer.id === action.signerId ? _objectSpread(_objectSpread({}, signer), {}, {
              data: _objectSpread(_objectSpread({}, signer.data), {}, {
                email: action.email
                // addons: {
                //   ...signer.data.addons || {},
                //   shareDocumentAfterSigned: action.email ? signer.data?.addons?.shareDocumentAfterSigned : false,
                // },
              })
            }) : _objectSpread({}, signer);
          })
        })
      });
    case 'RECIPIENT_SAVE_REQUEST':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: state.data.signers.map(function (item) {
            if (item.id === action.id) {
              return _objectSpread(_objectSpread({}, item), {}, {
                isSaving: true,
                error: null // reseting the error
              });
            }
            return item;
          })
        })
      });
    case 'RECIPIENT_SAVE_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: state.data.signers.map(function (item) {
            if (item.id === action.id) {
              return _objectSpread(_objectSpread({}, item), {}, {
                isSaving: false,
                error: null
              });
            }
            return item;
          })
        })
      });
    case 'RECIPIENT_SAVE_FAILURE':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: state.data.signers.map(function (item) {
            if (item.id === action.id) {
              return _objectSpread(_objectSpread({}, item), {}, {
                isSaving: false,
                error: action.error //setting the error
              });
            }
            return item;
          })
        })
      });
    case 'UPDATE_RECIPIENT':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: _toConsumableArray(state.data.signers.map(function (item) {
            if (item.id === action.id) {
              return _objectSpread(_objectSpread(_objectSpread({}, item), action.recipient), {}, {
                error: null
              });
            }
            return item;
          }))
        })
      });
    case 'REMOVE_RECIPIENT':
      var remainingRecipients = state.data.signers.filter(function (item) {
        return item.id !== action.id;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: remainingRecipients,
          advanced: _objectSpread(_objectSpread({}, state.data.advanced), {}, {
            numberOfSigners: Math.min(state.data.advanced.numberOfSigners, remainingRecipients.length)
          })
        })
      });
    case 'OPTIONS_FORM_BLUR':
      return _objectSpread(_objectSpread({}, state), {}, {
        touched: _objectSpread(_objectSpread({}, state.touched), {}, _defineProperty({}, action.fieldName, true))
      });
    case 'UPDATE_RECIPIENTS':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: action.recipients
        })
      });
    case 'SET_DEFAULT_SIGNERS_ROLES':
      var _action$payload = action.payload,
        fileCategory = _action$payload.fileCategory,
        fileId = _action$payload.fileId;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: state.data.signers.map(function (signer) {
            var existingValue = signer.data.signerRoles[action.payload.fileId];
            var result = 'sign';
            if (fileCategory === 'attachment') result = existingValue && !existingValue === 'sign' ? existingValue : 'view';
            return _objectSpread(_objectSpread({}, signer), {}, {
              data: _objectSpread(_objectSpread({}, signer.data), {}, {
                signerRoles: _objectSpread(_objectSpread({}, signer.data.signerRoles), {}, _defineProperty(_defineProperty({}, action.payload.fileId, result), fileId, result))
              })
            });
          })
        })
      });
    case 'SET_SIGNER_ROLES':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: state.data.signers.map(function (signer) {
            return signer.id === action.payload.signerId ? _objectSpread(_objectSpread({}, signer), {}, {
              data: _objectSpread(_objectSpread({}, signer.data), {}, {
                signerRoles: _objectSpread(_objectSpread({}, signer.data.signerRoles), {}, _defineProperty({}, action.payload.fileId, action.payload.fileCategory === 'document' ? 'sign' : 'view'))
              })
            }) : signer;
          })
        })
      });
    case 'REMOVE_FILE_SIGNER_ROLES':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          signers: state.data.signers.map(function (signer) {
            var newSignerRoles = Object.assign({}, _objectSpread({}, signer.data.signerRoles));
            if (signer.data.signerRoles[action.fileId]) {
              delete newSignerRoles[action.fileId];
            }
            return _objectSpread(_objectSpread({}, signer), {}, {
              data: _objectSpread(_objectSpread({}, signer.data), {}, {
                signerRoles: newSignerRoles
              })
            });
          })
        })
      });
    case 'ORDER_EDIT':
      // endpoint uiFeatures are different and that is why i set documents&&attachments manually and not the whole order
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          documents: action.order.documents,
          attachments: action.order.attachments
        })
      });
    case 'ADD_FAILED_UPLOADS':
      return _objectSpread(_objectSpread({}, state), {}, {
        fileUploadErrors: action.files
      });
    case 'REMOVE_FAILED_UPLOADS':
      return _objectSpread(_objectSpread({}, state), {}, {
        fileUploadErrors: []
      });
    default:
      return state;
  }
});